import { motion } from 'motion/react'

interface TabBarButtonProps {
  isSelected: boolean
  onClick: () => void
  label: string
  icon: JSX.Element
}

const TabBarButton = ({
  isSelected,
  onClick,
  label,
  icon
}: TabBarButtonProps) => (
  <button type='button' onClick={onClick} className='h-full w-full'>
    <motion.div
      className={`rounded-lg flex items-center flex-col justify-around ${
        isSelected ? 'text-[#08724C] bg-green-100' : 'text-[#A197C1]'
      }`}
    >
      <div className='flex'>{icon}</div>
      <span className='text-[0.625rem] font-semibold'>{label}</span>
    </motion.div>
  </button>
)

export default TabBarButton
